import { TAuthConfig } from 'react-oauth2-code-pkce';
import config from '../config';

export const authConfig: TAuthConfig = {
  clientId: config.REACT_APP_SALESFORCE_CLIENT_ID,
  authorizationEndpoint: config.REACT_APP_SALESFORCE_AUTHORIZATION_ENDPOINT,
  tokenEndpoint: config.REACT_APP_SALESFORCE_TOKEN_ENDPOINT,
  tokenExpiresIn: 30,
  refreshTokenExpiresIn: 259000,
  redirectUri: config.REACT_APP_SALESFORCE_REDIRECT_URI,
  // logoutEndpoint: config.REACT_APP_SALESFORCE_REVOKE_ENDPOINT,
  // logoutRedirect: config.REACT_APP_SALESFORCE_REDIRECT_URI,
  autoRefreshToken: false,
  onRefreshTokenExpire: (event) => window.confirm('Session has expired. Refresh page to continue using the site') && event.login(),

  // Example to redirect back to original path after login has completed
  // preLogin: () => localStorage.setItem('preLoginPath', window.location.pathname),
  // postLogin: () => window.location.replace(localStorage.getItem('preLoginPath') || '/'),
  scope: '',
  decodeToken: false,
  autoLogin: false,
};
